import React, { useState, useEffect } from "react";
import { AiOutlineUp } from "react-icons/ai";
import styled from "styled-components";

function ScrollToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.pageYOffset > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = (e) => {
    e.preventDefault();
    const duration = 500;
    const start = window.pageYOffset;
    const startTime = performance.now();

    const animateScroll = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const ease = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, start * (1 - ease));
      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  };

  return (
    <Div>
      <button
        href="#"
        className={`scrollToTop ${visible ? "block" : "none"}`}
        onClick={scrollToTop}
        >
        <AiOutlineUp />
      </button>
    </Div>
  );
}

const Div = styled.div`
  max-width: 100vw;
  .none {
    opacity: 0;
    visibility: hidden;
  }
  button {
    position: fixed;
    bottom: 40px;
    right: 40px;
    background-color: var(--dark-text);
    padding: 1rem;
    border: none;
    cursor: pointer;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.4s ease-in-out;
    z-index: 1;
    svg {
      color: var(--dark-footer);
      font-size: 1.3rem;
    }
    @media screen and (min-width: 280px) and (max-width: 1080px) {
      left: 85vw;
      right: initial;
      bottom: 50px;
      padding: 1rem;
    }
    @media only screen and (max-width: 960px) {
      left: 85vw;
    }
  }
`;

export default ScrollToTop;